import { inject } from "@angular/core";


import { tapResponse } from "@ngrx/operators";
import { patchState, signalStore, withHooks, withMethods, withState } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { MandantService } from "@sortapp/app/api/advsortiment/services/mandant.service";
import { VorschlagDtoClient as VorschlagDtoClient, VorschlagFlatDtoClient } from "@sortapp/app/models/vorschlaege/vorschlagDTOClient";

import { NoviColumn, SimpleResultError, WupColumnType } from "FoxxyInterfaces";
import { CommonCheckService, EnvironmentService } from "FoxxyLib";

import { mergeMap, pipe, switchMap } from "rxjs";
import { GraphQlParam } from "@sortapp/app/models/commondto/GraphQlParam";
import { Apollo } from "apollo-angular";
import { FlexModelColumnData } from "@sortapp/app/models/commondto/FlexColumnClientDto";
import { VorschlaegePivotparam } from "@sortapp/app/cockpit/store/cockpitStore";
import { GraphQlEndpoint } from "@sortapp/app/graphql.service";



/**Type of States */
type VorschlagDetailState = {


  vorschlagError: SimpleResultError,
  vorschlag: VorschlagDtoClient,

  filialBestaendColumns: NoviColumn[],
  filialBestaende: any[],
  isLoading: boolean,
  artikelInfos: {[key: string]: any};
  vorschlagSuccess: VorschlagSuccess,
  weitereplatzierungen: any[]
};

type VorschlagSuccess =
  {
    message: string;
  }


export const VorschlagDetailStore = signalStore(
  withHooks({
    onInit(store) {



    }
  }),
  withState(<VorschlagDetailState>{
    vorschlaegeHits: {},
    vorschlag: null,
    vorschlagError: <SimpleResultError>null,
    isLoading: false,
    vorschlagSuccess: <VorschlagSuccess>null,
    filialBestaendColumns: [],
    filialBestaende: [],
    weitereplatzierungen: [],
    artikelInfos: {}

  }),
  withMethods(
    (
      store,
      mandantService = inject(MandantService),
      commonvalidaService = inject(CommonCheckService),
      enVService = inject(EnvironmentService),
      apollo = inject(Apollo),

    ) => ({
      getWeiterePlatzierungen: rxMethod<GraphQlParam>(
        pipe(
          switchMap((param) => {
            patchState(store, { isLoading: true });
            return apollo
              .query<any>({
                query: param.query,
                variables: param.variables
              }).pipe(tapResponse({
                next: (result) => {
                  try {

                    const dtos = result.data[param.operation].items.map(s => commonvalidaService.getFlatObject(s, [], '_'));
                    dtos.forEach(dto => {
                      const pivotobjects = commonvalidaService.getPivotObjectValues(
                        [
                          "moebel_id",
                          "moebel_name",
                        ]
                        , dto['platzierungen'], "modulNumber", [])
                      for (const fld in pivotobjects) {
                        dto["platzierungen_" + fld] = pivotobjects[fld];
                      }
                    })

                    patchState(store, {
                      isLoading: false,
                      weitereplatzierungen: dtos
                    });
                  } catch (e) {
                    patchState(store, { isLoading: false, vorschlagError: SimpleResultError.getSimpleResultError(e, "Weitere Platzierungen laden") });
                  }
                }
                ,
                error: (error) => {
                  patchState(store, { isLoading: false, vorschlagError: SimpleResultError.getSimpleResultError(error, "Weitere Platzierungen laden") });
                }
              }
              )
              )
          })),

      ),



      GetFilialBestand: rxMethod<GraphQlParam>(
        pipe(
          switchMap((param) => {
            patchState(store, { isLoading: true });
            return apollo
              .query<any>({
                query: param.query,
                variables: param.variables
              }).pipe(tapResponse({
                next: (result) => {
                  try {
                    if (result.data[param.operation] ) {
                      const dtos = result.data[param.operation].items;
                      if (dtos.length > 1) {
                        patchState(store, { vorschlagError: SimpleResultError.getSimpleResultError(new Error("Kennzahlen für Bestand nicht eindeutig"), "Filialbestände laden") });
                      } else if (dtos.length == 1) {
                        let pivotobjects = commonvalidaService.getPivotObjectValues(["kennzahlen_filialLagerBestand"], dtos[0]["platzierungen"], "modulNumber", [], '_');
                        if (pivotobjects == null) { pivotobjects = {}; }
                        var cols = [];
                        const keys = Object.keys(pivotobjects);
                        keys.forEach(k => {
                          cols.push(<NoviColumn>{ style: 'width: 1.5rem; text-align: right;', field: k, header: 'M' + k.slice(k.length - 2).replace("_", ""), type: WupColumnType.Number })
                        }
                        )
                        patchState(store, {
                          isLoading: false,
                          filialBestaendColumns: cols,
                          filialBestaende: [pivotobjects]
                        });
                      } else {
                       var cols = [];
                       cols.push(<NoviColumn>{ field: 'no', header: 'Keine Filialbestände', type: WupColumnType.Text })
                        patchState(store, {
                          isLoading: false,
                          filialBestaendColumns: cols,
                          filialBestaende: [{no: ''}]
                        });
                    }
                  }
                  } catch (e) {
                    patchState(store, { isLoading: false, vorschlagError: SimpleResultError.getSimpleResultError(e, "Filialbestände laden") });
                  }
                }
                ,
                error: (error) => {
                  patchState(store, { isLoading: false, vorschlagError: SimpleResultError.getSimpleResultError(error, "Filialbestände laden") });
                }
              }
              )
              )
          })),

      ),

      getVorschlag: rxMethod<MandantService.MandantQueryParams>(
        pipe(
          mergeMap((param) => {
            mandantService.rootUrl = enVService.environment.connections.ADVSortimentWebapi;
            patchState(store, { vorschlagError: null, isLoading: true });
            return mandantService.MandantQueryResponse(param).pipe(
              tapResponse({
                next: (r) => {
                  patchState(store, { vorschlagError: null, isLoading: false });
                  try {
                    if (r && r.body && r.body.error) {
                      patchState(store, { vorschlagError: SimpleResultError.getSimpleResultError(r.body, "Fehler Vorschläge laden") });
                      return;
                    }
                    if (r != undefined && r.body != undefined && r.body.result.length == 1) {
                      patchState(store, { vorschlag: new VorschlagDtoClient(r.body.result[0]) });
                    } else {
                      throw new Error("Vorschlag nicht gefunden");
                    }
                  } catch (e) {
                    patchState(store, { vorschlagError: SimpleResultError.getSimpleResultError(e, "Fehler Vorschläge laden") });
                  }
                },
                error: (error) => {

                  patchState(store, { isLoading: false, vorschlagError: SimpleResultError.getSimpleResultError(error, "Vorschlag laden") });
                },
              }),
            )
          }))),
      vorschlagEntfernen: rxMethod<MandantService.MandantRemoveParams>(
        pipe(
          mergeMap((param) => {
            mandantService.rootUrl = enVService.environment.connections.ADVSortimentWebapi;
            return mandantService.MandantRemoveResponse(param).pipe(
              tapResponse({
                next: (result) => {
                  if (result.body.error == true) {
                    patchState(store, { vorschlagError: SimpleResultError.getSimpleResultError(result.body, "Fehler Vorschlag entfernen") });
                  } else {
                    patchState(store, { vorschlagSuccess: { message: "Vorschlag entfernen" } });
                  }
                },
                error: (error) => {

                  patchState(store, { isLoading: false, vorschlagError: SimpleResultError.getSimpleResultError(error, "Vorschläge entfernen") });
                },
              }),
            )
          }))),
      vorschlagZurueckstellen: rxMethod<MandantService.MandantDeferParams>(
        pipe(
          mergeMap((param) => {
            mandantService.rootUrl = enVService.environment.connections.ADVSortimentWebapi;
            return mandantService.MandantDeferResponse(param).pipe(
              tapResponse({
                next: (result) => {
                  if (result.body.error == true) {
                    patchState(store, { vorschlagError: SimpleResultError.getSimpleResultError(result.body, "Fehler Vorschlag zurückstellen") });
                  } else {
                    patchState(store, { vorschlagSuccess: { message: "Vorschlag zurückgestellt (" + param.days + ")" } });
                  }
                },
                error: (error) => {

                  patchState(store, { vorschlagSuccess: null, isLoading: false, vorschlagError: SimpleResultError.getSimpleResultError(error, "Vorschläge zurückgestellt") });
                },
              }),
            )
          }))),

    })
  )
)


//for Constructor injection
export type VorschlagDetailStore = InstanceType<typeof VorschlagDetailStore>;
